import { jwtDecode as decode } from "jwt-decode";
import { getToken } from "./token";

/**
 * 讀取目前登入者的「動作權限」（task.delete、setting.edit 這類）。
 *
 * 為什麼不用 Redux 裡的 Role.PermissionsUser：
 * 那份清單是 /Auth/RolePermissions 回來的，刻意只保留 action='view' 的模組碼
 * （dashboard、setting、task…），用途是決定側欄要顯示哪些項目。
 * 動作權限混進去會讓側欄的比對語意糊掉，所以沒有放。
 *
 * access_token 本身的 permission claim 則是完整的 45 筆，格式為
 * "{id}:{名稱}:{模組碼}" 以逗號分隔——後端 PermissionHandler 也是比對第三段。
 * 這裡只用來決定畫面要不要顯示某個區塊；真正的把關一律在後端的 [PermissionOnly]。
 */
export function actionPermissions() {
  const token = getToken();
  if (!token) return [];
  try {
    const claim = decode(token).permission;
    return String(claim || "")
      .split(",")
      .map((p) => p.split(":")[2])
      .filter(Boolean)
      .map((s) => s.trim());
  } catch {
    return [];
  }
}

/** 目前登入者是否具備指定權限碼（例 "setting.edit"） */
export function hasPermission(code) {
  return actionPermissions().some((p) => p.toLowerCase() === String(code).toLowerCase());
}
